
import React, { useState } from 'react';
import './expertCards.css';
import Grid from '@mui/material/Unstable_Grid2';
import Avatar from '@mui/material/Avatar';
import Card from './Card/Card';

function ExpertCards() {
  return(
    <Grid container spacing={2}>
      <Grid xs={3}>
        <Card name='Terry Tao' subject='Mathematics' monthlyFees='3000' imgSrc='/images/terry_tao.png'/>
      </Grid>
      <Grid xs={3}>
        <Card name='Stephan Devassy' subject='Piano' monthlyFees='2,000' imgSrc='/images/stephan_devassy.png'/>
      </Grid>
      <Grid xs={3}>
        <Card name='Paul Sebastian' subject='Physics' monthlyFees='900' imgSrc='/images/paul.jpg'/>
      </Grid>
      <Grid xs={3}>
        <Card name='Andrej Karpathy' subject='Computer Engineering' monthlyFees='3,000' imgSrc='/images/andrej_karpathy.jpg'/>
      </Grid>

      <Grid xs={3}>
        <Card name='Hormis Cheriyan' subject='Taekwondo' monthlyFees='1,200' imgSrc='/images/urumi.png'/>
      </Grid>
      <Grid xs={3}>
        <Card name='Iman Soltani' subject='Aerospace Engineering' monthlyFees='2,000' imgSrc='/images/iman_soltani.jpg'/>
      </Grid>
      <Grid xs={3}>
        <Card name='Anne Elizabeth' subject='History' monthlyFees='900' imgSrc='/images/anne_elizabeth.jpg'/>
      </Grid>
      <Grid xs={3}>
        <Card name='Mikhail Lukin' subject='Quantum Physics' monthlyFees='4,000' imgSrc='/images/mikhail_lukin.jpg'/>
      </Grid>
    </Grid>
  );}

export default ExpertCards;




